import { Component, ViewChild, ElementRef, OnInit, OnDestroy, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import * as faceapi from 'face-api.js';

@Component({
    selector: 'app-face-capture',
    templateUrl: './face-capture.component.html',
    styleUrls: ['./face-capture.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FaceCaptureComponent implements OnInit, OnDestroy {
    @Input() allowTakePhoto: boolean = false;
    @Output() saveImage: EventEmitter<string> = new EventEmitter<string>();
    @Output() webcamStarted: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;
    detectionStatus = 'Carregando modelos...';
    detectionInterval: any;
    capturedImage: string | null = null;
    stream!: MediaStream;
    capturing: boolean = false; // para evitar múltiplas capturas

    async ngOnInit() {
        this.webcamStarted.emit(false);
        await Promise.all([
            faceapi.nets.ssdMobilenetv1.loadFromUri('/assets/models'),
            faceapi.nets.faceLandmark68Net.loadFromUri('/assets/models'),
            faceapi.nets.faceRecognitionNet.loadFromUri('/assets/models')
        ]);
        await this.startWebcam();
    }

    async startWebcam() {
        this.webcamStarted.emit(false);
        this.capturedImage = null;
        this.capturing = false;
        this.detectionStatus = 'Iniciando webcam...';
        this.stream = await navigator.mediaDevices.getUserMedia({ video: true });
        this.videoElement.nativeElement.srcObject = this.stream;
        await this.videoElement.nativeElement.play();
        this.startFaceDetection();
    }

    startFaceDetection() {
        this.webcamStarted.emit(true);
        this.detectionInterval = setInterval(async () => {
            if (this.capturing) return;
            if (this.allowTakePhoto) {
                const detections = await faceapi.detectAllFaces(
                    this.videoElement.nativeElement,
                    new faceapi.SsdMobilenetv1Options()
                );
                if (detections.length === 1) {
                    this.detectionStatus = 'Rosto detectado! Tirando foto...';
                    this.capturing = true;
                    this.capture();
                } else if (detections.length > 1) {
                    this.detectionStatus = 'Múltiplos rostos detectados. Enquadre apenas o pessoa paciente sendo atendido.';
                }
            } else {
                this.detectionStatus = 'Para obter uma fotografia de qualidade, posicione o rosto do paciente dentro da moldura oval, garantindo que todo o espaço seja preenchido.';
            }
        }, 1000);
    }

    capture() {
        const video = this.videoElement.nativeElement;
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const ctx = canvas.getContext('2d')!;
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        this.capturedImage = canvas.toDataURL('image/jpeg');
        this.detectionStatus = 'Imagem capturada. Por favor, verifique se o rosto está nítido, bem enquadrado e com o rosto totalmente visível.. Caso a qualidade não seja satisfatória, capture uma nova foto.';
        this.saveImage.emit(this.capturedImage);
        clearInterval(this.detectionInterval);
        this.stream.getTracks().forEach(track => track.stop());
    }

    ngOnDestroy() {
        clearInterval(this.detectionInterval);
        if (this.stream) {
            this.stream.getTracks().forEach(track => track.stop());
        }
    }
}
